"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _activity = require('./activity');
var _auth = require('./auth');
var _inbox = require('./inbox');
var _directory = require('./directory');
var _broadcast = require('./broadcast');
var _messageTemplate = require('./messageTemplate');
var _settings = require('./settings');
var _alert = require('./alert');
var _app = require('./app');
var _upgrade = require('./upgrade');
var _notifications = require('./notifications');
var _onboarding = require('./onboarding');
var _session = require('./session');
var _chat = require('./chat');
var _patientConversation = require('./patientConversation');
var _call = require('./call');
var _scheduledMessages = require('./scheduledMessages');
var _requests = require('./requests');
var _patientProfile = require('./patientProfile');
var _translation = require('./translation');
var _patientTable = require('./patientTable');

const actionCreators = {
  ..._settings.actionCreators,
  ..._activity.actionCreators,
  ..._app.actionCreators,
  ..._auth.actionCreators,
  ..._alert.actionCreators,
  ..._inbox.actionCreators,
  ..._directory.actionCreators,
  ..._broadcast.actionCreators,
  ..._messageTemplate.actionCreators,
  ..._upgrade.actionCreators,
  ..._notifications.actionCreators,
  ..._onboarding.actionCreators,
  ..._session.actionCreators,
  ..._chat.actionCreators,
  ..._patientConversation.actionCreators,
  ..._call.actionCreators,
  ..._scheduledMessages.actionCreators,
  ..._requests.actionCreators,
  ..._patientProfile.actionCreators,
  ..._translation.actionCreators,
  ..._patientTable.actionCreators,
}

exports. default = actionCreators
